// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OfferingDetailPage {
  width: 100%;
  padding-bottom: 0;
}

.off-detail-loader-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 80vh;
  color: rgba(255, 255, 255, 0.5);
}

.off-detail-spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(72, 209, 204, 0.1);
  border-top-color: #48d1cc;
  border-radius: 50%;
  animation: spinner-spin 0.8s linear infinite;
  margin-bottom: 16px;
}

/* Hero section style */
.off-detail-hero {
  position: relative;
  height: 380px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
  padding-top: 80px;
  /* Offset fixed site header */
}

.off-detail-hero__bg {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  z-index: 1;
}

.off-detail-hero__overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to bottom, rgba(8, 14, 6, 0.4) 0%, rgba(8, 14, 6, 0.95) 100%);
  z-index: 2;
}

.off-detail-hero__content {
  position: relative;
  z-index: 3;
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px 32px 40px;
  box-sizing: border-box;
}

.off-detail-breadcrumb {
  font-size: 13px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.off-detail-breadcrumb .c-gold {
  color: #48d1cc;
  font-weight: 700;
}

.off-detail-title {
  font-size: clamp(28px, 4.5vw, 46px);
  font-weight: 900;
  line-height: 1.15;
  color: #ffffff;
  margin: 0;
}

/* Two Column Body layout */
.off-detail-body {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 40px;
  box-sizing: border-box;
}

.off-detail-columns {
  display: flex;
  gap: 40px;
  align-items: flex-start;
}

.off-detail-main {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 36px;
}

.off-detail-sidebar {
  width: 360px;
  flex-shrink: 0;
  position: sticky;
  top: 100px;
  z-index: 100;
}

/* Inner Sections styling */
.off-detail-section {
  background-color: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 18px;
  padding: 28px;
}

.off-detail-section-title {
  font-size: 18px;
  font-weight: 800;
  color: #48d1cc;
  margin-top: 0;
  margin-bottom: 18px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-left: 3px solid #48d1cc;
  padding-left: 10px;
}

.off-detail-description {
  font-size: 15.5px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.72);
  margin: 0;
  white-space: pre-line;
}

/* Gallery Grid */
.off-detail-gallery {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  gap: 16px;
}

.off-detail-gallery__item {
  position: relative;
  aspect-ratio: 1;
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.1);
  cursor: pointer;
}

.off-detail-gallery__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.off-detail-gallery__hover {
  position: absolute;
  inset: 0;
  background-color: rgba(8, 14, 6, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
}

.off-detail-gallery__hover span {
  font-size: 12px;
  font-weight: 700;
  color: #48d1cc;
  text-transform: uppercase;
}

.off-detail-gallery__item:hover .off-detail-gallery__img {
  transform: scale(1.05);
}

.off-detail-gallery__item:hover .off-detail-gallery__hover {
  opacity: 1;
}

/* Location details cards */
.off-detail-location-info {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.off-location-card {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  background-color: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.04);
  padding: 18px;
  border-radius: 12px;
}

.off-location-icon {
  font-size: 24px;
  line-height: 1;
}

.off-location-card h4 {
  margin: 0 0 6px 0;
  font-size: 15px;
  font-weight: 700;
  color: #fff;
}

.off-location-card p {
  margin: 0;
  font-size: 13.5px;
  color: rgba(255, 255, 255, 0.6);
  line-height: 1.5;
}

.off-location-split {
  display: flex;
  gap: 16px;
}

.off-location-split .off-location-card {
  flex: 1 1;
}

/* Tags styles */
.off-detail-tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.off-detail-tag {
  background-color: rgba(72, 209, 204, 0.08);
  border: 1px solid rgba(72, 209, 204, 0.2);
  border-radius: 20px;
  color: #48d1cc;
  padding: 6px 14px;
  font-size: 13px;
  font-weight: 600;
}

/* Provider profile card block */
.off-provider-card {
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.01);
  border: 1px solid rgba(255, 255, 255, 0.03);
  transition: background-color 0.2s, border-color 0.2s, transform 0.2s;
}

.off-provider-card:hover {
  background: rgba(255, 255, 255, 0.03);
  border-color: rgba(255, 255, 255, 0.08);
  transform: translateY(-2px);
}

.off-provider-avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid #48d1cc;
  flex-shrink: 0;
}

.off-provider-details h3 {
  font-size: 16px;
  font-weight: 700;
  margin: 0 0 8px 0;
  color: #ffffff;
}

.off-provider-bio {
  font-size: 13.5px;
  line-height: 1.6;
  color: rgba(255, 255, 255, 0.65);
  margin: 0 0 8px 0;
}

.off-provider-date {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
}

/* ─── Booking Sidebar Form Inputs ──────────────────────────────── */
.off-booking-form {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.off-booking-form__group {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.off-booking-form__label {
  font-size: 12px;
  font-weight: 700;
  color: rgba(255, 255, 255, 0.5);
  text-transform: uppercase;
  letter-spacing: 0.4px;
}

.off-booking-form__input {
  width: 100%;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #ffffff;
  padding: 11px 14px;
  font-size: 14px;
  font-family: 'Inter', inherit;
  outline: none;
  transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
  /* Style the native date/time pickers to match */
  color-scheme: dark;
}

.off-booking-form__input::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.off-booking-form__input:focus {
  border-color: #3bb3ae;
  background-color: rgba(255, 255, 255, 0.07);
  box-shadow: 0 0 0 2px rgba(59, 179, 174, 0.15);
}

/* Remove native spin buttons for number inputs */
.off-booking-form__input::-webkit-outer-spin-button,
.off-booking-form__input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.off-booking-form__input[type=number] {
  appearance: textfield;
}

.off-booking-form__textarea {
  width: 100%;
  box-sizing: border-box;
  background-color: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #ffffff;
  padding: 11px 14px;
  font-size: 14px;
  font-family: 'Inter', inherit;
  outline: none;
  resize: vertical;
  min-height: 90px;
  line-height: 1.5;
  transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
  color-scheme: dark;
}

.off-booking-form__textarea::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.off-booking-form__textarea:focus {
  border-color: #3bb3ae;
  background-color: rgba(255, 255, 255, 0.07);
  box-shadow: 0 0 0 2px rgba(59, 179, 174, 0.15);
}

.off-booking-form__char-count {
  display: block;
  font-size: 11px;
  color: rgba(255, 255, 255, 0.35);
  text-align: right;
  margin-top: 3px;
}

.off-booking-form__error {
  font-size: 12px;
  color: #ff6b6b;
  font-weight: 500;
  margin-top: 2px;
}

/* Price summary row inside form */
.off-booking-form__price-summary {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: rgba(59, 179, 174, 0.06);
  border: 1px solid rgba(59, 179, 174, 0.15);
  border-radius: 10px;
  padding: 12px 14px;
  margin-top: 4px;
}

.off-booking-form__price-label {
  font-size: 13px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
}

.off-booking-form__price-value {
  font-size: 16px;
  font-weight: 800;
  color: #48d1cc;
}

/* Booking sidebar card elements */
.off-booking-card {
  background-color: #0e1b1b;
  border: 1.5px solid rgba(72, 209, 204, 0.3);
  border-radius: 22px;
  padding: 28px;
  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);
}

.off-booking-card__price-row {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.off-booking-card__price {
  font-size: 28px;
  font-weight: 900;
  color: #48d1cc;
}

.off-booking-card__price-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 600;
}

.off-booking-card__desc {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
}

.off-booking-card__availability {
  margin-bottom: 24px;
}

.off-booking-card__availability h4 {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.5);
  margin: 0 0 8px 0;
}

.off-booking-card__availability p {
  font-size: 13.5px;
  line-height: 1.5;
  color: rgba(255, 255, 255, 0.75);
  margin: 0;
}

.off-booking-card__btn-book {
  background-color: #3bb3ae;
  border: none;
  color: #071414;
  width: 100%;
  font-family: inherit;
  font-size: 14px;
  font-weight: 700;
  padding: 14px 20px;
  border-radius: 30px;
  cursor: pointer;
  outline: none;
  min-height: 48px;
  text-align: center;
  box-sizing: border-box;
  transition: all 0.2s ease;
}

.off-booking-card__btn-book:hover {
  opacity: 0.9;
  box-shadow: 0 4px 12px rgba(59, 179, 174, 0.3);
}

.off-booking-card__helper-text {
  text-align: center;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.35);
  margin: 6px 0 20px 0;
}

.off-booking-card__divider {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.08);
  margin-bottom: 20px;
}

.off-booking-card__btn-quote {
  background: transparent;
  border: 1px solid rgba(72, 209, 204, 0.3);
  color: #48d1cc;
  cursor: pointer;
  font-family: inherit;
  font-size: 13px;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 30px;
  width: 100%;
  min-height: 40px;
  transition: all 0.2s ease;
}

.off-booking-card__btn-quote:hover {
  background-color: rgba(72, 209, 204, 0.1);
}

/* Lightbox overlays */
.off-lightbox {
  position: fixed;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 12000;
  cursor: zoom-out;
  backdrop-filter: blur(8px);
}

.off-lightbox__content {
  position: relative;
  max-width: 90%;
  max-height: 85%;
}

.off-lightbox__img {
  max-width: 100%;
  max-height: 80vh;
  object-fit: contain;
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);
}

.off-lightbox__close {
  position: absolute;
  top: -48px;
  right: 0;
  background: none;
  border: none;
  color: #fff;
  font-size: 36px;
  cursor: pointer;
  outline: none;
}

.off-lightbox__close:hover {
  color: #48d1cc;
}

@media (max-width: 960px) {
  .off-detail-columns {
    flex-direction: column;
    gap: 30px;
  }

  .off-detail-sidebar {
    width: 100%;
    position: static;
  }
}

@media (max-width: 600px) {
  .off-detail-hero {
    height: 300px;
  }

  .off-detail-body {
    padding: 0 20px;
  }

  .off-detail-hero__content {
    padding: 0 20px 24px 20px;
  }

  .off-detail-section {
    padding: 20px;
  }

  .off-location-split {
    flex-direction: column;
  }
}

@media (max-width: 768px) {
  .OfferingDetailPage {
    height: auto !important;
    overflow: visible !important;
  }
}

/* Custom Dropdown Styling */
.custom-dropdown-container {
  position: relative;
  width: 100%;
}

.custom-dropdown-selected {
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
}

.custom-dropdown-selected.active {
  border-color: #3bb3ae;
  box-shadow: 0 0 0 2px rgba(59, 179, 174, 0.15);
}

.custom-dropdown-options {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  width: 100%;
  max-height: 220px;
  overflow-y: auto;
  border-radius: 10px;
  border: 1px solid rgba(72, 209, 204, 0.25);
  background-color: #071414;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  z-index: 1000;
  padding: 6px 0;
  box-sizing: border-box;
}

.custom-dropdown-option {
  padding: 10px 16px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.15s ease;
  text-align: left;
}

.custom-dropdown-option:hover {
  background-color: rgba(72, 209, 204, 0.1);
  color: #ffffff;
}

.custom-dropdown-option.selected {
  background-color: rgba(72, 209, 204, 0.15);
  color: #48d1cc;
  font-weight: 600;
}`, "",{"version":3,"sources":["webpack://./src/Pages/OfferingDetailPage/OfferingDetailPage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yCAAyC;EACzC,yBAAyB;EACzB,kBAAkB;EAClB,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,aAAa;EACb,aAAa;EACb,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,yFAAyF;EACzF,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,2CAA2C;EAC3C,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;EACT,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,2CAA2C;EAC3C,2CAA2C;EAC3C,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;AACT;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,0CAA0C;EAC1C,yCAAyC;EACzC,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,qCAAqC;EACrC,2CAA2C;EAC3C,oEAAoE;AACtE;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,qEAAqE;AACrE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,2CAA2C;EAC3C,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,oFAAoF;EACpF,gDAAgD;EAChD,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA,iDAAiD;AACjD;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA;EAEE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,2CAA2C;EAC3C,0CAA0C;EAC1C,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oFAAoF;EACpF,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,mBAAmB;EACnB,aAAa;EACb,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,yCAAyC;EACzC,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,QAAQ;EACR,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;AACF;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,yBAAyB;EACzB,yCAAyC;EACzC,aAAa;EACb,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;EACd,gBAAgB;AAClB","sourcesContent":[".OfferingDetailPage {\n  width: 100%;\n  padding-bottom: 0;\n}\n\n.off-detail-loader-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 80vh;\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.off-detail-spinner {\n  width: 40px;\n  height: 40px;\n  border: 4px solid rgba(72, 209, 204, 0.1);\n  border-top-color: #48d1cc;\n  border-radius: 50%;\n  animation: spinner-spin 0.8s linear infinite;\n  margin-bottom: 16px;\n}\n\n/* Hero section style */\n.off-detail-hero {\n  position: relative;\n  height: 380px;\n  display: flex;\n  align-items: flex-end;\n  overflow: hidden;\n  padding-top: 80px;\n  /* Offset fixed site header */\n}\n\n.off-detail-hero__bg {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: center;\n  z-index: 1;\n}\n\n.off-detail-hero__overlay {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(to bottom, rgba(8, 14, 6, 0.4) 0%, rgba(8, 14, 6, 0.95) 100%);\n  z-index: 2;\n}\n\n.off-detail-hero__content {\n  position: relative;\n  z-index: 3;\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 40px 32px 40px;\n  box-sizing: border-box;\n}\n\n.off-detail-breadcrumb {\n  font-size: 13px;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.6);\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.off-detail-breadcrumb .c-gold {\n  color: #48d1cc;\n  font-weight: 700;\n}\n\n.off-detail-title {\n  font-size: clamp(28px, 4.5vw, 46px);\n  font-weight: 900;\n  line-height: 1.15;\n  color: #ffffff;\n  margin: 0;\n}\n\n/* Two Column Body layout */\n.off-detail-body {\n  width: 100%;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 40px;\n  box-sizing: border-box;\n}\n\n.off-detail-columns {\n  display: flex;\n  gap: 40px;\n  align-items: flex-start;\n}\n\n.off-detail-main {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 36px;\n}\n\n.off-detail-sidebar {\n  width: 360px;\n  flex-shrink: 0;\n  position: sticky;\n  top: 100px;\n  z-index: 100;\n}\n\n/* Inner Sections styling */\n.off-detail-section {\n  background-color: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 18px;\n  padding: 28px;\n}\n\n.off-detail-section-title {\n  font-size: 18px;\n  font-weight: 800;\n  color: #48d1cc;\n  margin-top: 0;\n  margin-bottom: 18px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  border-left: 3px solid #48d1cc;\n  padding-left: 10px;\n}\n\n.off-detail-description {\n  font-size: 15.5px;\n  line-height: 1.7;\n  color: rgba(255, 255, 255, 0.72);\n  margin: 0;\n  white-space: pre-line;\n}\n\n/* Gallery Grid */\n.off-detail-gallery {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));\n  gap: 16px;\n}\n\n.off-detail-gallery__item {\n  position: relative;\n  aspect-ratio: 1;\n  border-radius: 12px;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  cursor: pointer;\n}\n\n.off-detail-gallery__img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.off-detail-gallery__hover {\n  position: absolute;\n  inset: 0;\n  background-color: rgba(8, 14, 6, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.off-detail-gallery__hover span {\n  font-size: 12px;\n  font-weight: 700;\n  color: #48d1cc;\n  text-transform: uppercase;\n}\n\n.off-detail-gallery__item:hover .off-detail-gallery__img {\n  transform: scale(1.05);\n}\n\n.off-detail-gallery__item:hover .off-detail-gallery__hover {\n  opacity: 1;\n}\n\n/* Location details cards */\n.off-detail-location-info {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.off-location-card {\n  display: flex;\n  align-items: flex-start;\n  gap: 16px;\n  background-color: rgba(255, 255, 255, 0.02);\n  border: 1px solid rgba(255, 255, 255, 0.04);\n  padding: 18px;\n  border-radius: 12px;\n}\n\n.off-location-icon {\n  font-size: 24px;\n  line-height: 1;\n}\n\n.off-location-card h4 {\n  margin: 0 0 6px 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #fff;\n}\n\n.off-location-card p {\n  margin: 0;\n  font-size: 13.5px;\n  color: rgba(255, 255, 255, 0.6);\n  line-height: 1.5;\n}\n\n.off-location-split {\n  display: flex;\n  gap: 16px;\n}\n\n.off-location-split .off-location-card {\n  flex: 1;\n}\n\n/* Tags styles */\n.off-detail-tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n\n.off-detail-tag {\n  background-color: rgba(72, 209, 204, 0.08);\n  border: 1px solid rgba(72, 209, 204, 0.2);\n  border-radius: 20px;\n  color: #48d1cc;\n  padding: 6px 14px;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n/* Provider profile card block */\n.off-provider-card {\n  display: flex;\n  gap: 20px;\n  align-items: center;\n  padding: 16px;\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.01);\n  border: 1px solid rgba(255, 255, 255, 0.03);\n  transition: background-color 0.2s, border-color 0.2s, transform 0.2s;\n}\n\n.off-provider-card:hover {\n  background: rgba(255, 255, 255, 0.03);\n  border-color: rgba(255, 255, 255, 0.08);\n  transform: translateY(-2px);\n}\n\n.off-provider-avatar {\n  width: 72px;\n  height: 72px;\n  border-radius: 50%;\n  object-fit: cover;\n  border: 2px solid #48d1cc;\n  flex-shrink: 0;\n}\n\n.off-provider-details h3 {\n  font-size: 16px;\n  font-weight: 700;\n  margin: 0 0 8px 0;\n  color: #ffffff;\n}\n\n.off-provider-bio {\n  font-size: 13.5px;\n  line-height: 1.6;\n  color: rgba(255, 255, 255, 0.65);\n  margin: 0 0 8px 0;\n}\n\n.off-provider-date {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n/* ─── Booking Sidebar Form Inputs ──────────────────────────────── */\n.off-booking-form {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.off-booking-form__group {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.off-booking-form__label {\n  font-size: 12px;\n  font-weight: 700;\n  color: rgba(255, 255, 255, 0.5);\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n}\n\n.off-booking-form__input {\n  width: 100%;\n  box-sizing: border-box;\n  background-color: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  color: #ffffff;\n  padding: 11px 14px;\n  font-size: 14px;\n  font-family: 'Inter', inherit;\n  outline: none;\n  transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;\n  /* Style the native date/time pickers to match */\n  color-scheme: dark;\n}\n\n.off-booking-form__input::placeholder {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.off-booking-form__input:focus {\n  border-color: #3bb3ae;\n  background-color: rgba(255, 255, 255, 0.07);\n  box-shadow: 0 0 0 2px rgba(59, 179, 174, 0.15);\n}\n\n/* Remove native spin buttons for number inputs */\n.off-booking-form__input::-webkit-outer-spin-button,\n.off-booking-form__input::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n.off-booking-form__input[type=number] {\n  -moz-appearance: textfield;\n  appearance: textfield;\n}\n\n.off-booking-form__textarea {\n  width: 100%;\n  box-sizing: border-box;\n  background-color: rgba(255, 255, 255, 0.04);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  color: #ffffff;\n  padding: 11px 14px;\n  font-size: 14px;\n  font-family: 'Inter', inherit;\n  outline: none;\n  resize: vertical;\n  min-height: 90px;\n  line-height: 1.5;\n  transition: border-color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;\n  color-scheme: dark;\n}\n\n.off-booking-form__textarea::placeholder {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.off-booking-form__textarea:focus {\n  border-color: #3bb3ae;\n  background-color: rgba(255, 255, 255, 0.07);\n  box-shadow: 0 0 0 2px rgba(59, 179, 174, 0.15);\n}\n\n.off-booking-form__char-count {\n  display: block;\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.35);\n  text-align: right;\n  margin-top: 3px;\n}\n\n.off-booking-form__error {\n  font-size: 12px;\n  color: #ff6b6b;\n  font-weight: 500;\n  margin-top: 2px;\n}\n\n/* Price summary row inside form */\n.off-booking-form__price-summary {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  background-color: rgba(59, 179, 174, 0.06);\n  border: 1px solid rgba(59, 179, 174, 0.15);\n  border-radius: 10px;\n  padding: 12px 14px;\n  margin-top: 4px;\n}\n\n.off-booking-form__price-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.off-booking-form__price-value {\n  font-size: 16px;\n  font-weight: 800;\n  color: #48d1cc;\n}\n\n/* Booking sidebar card elements */\n.off-booking-card {\n  background-color: #0e1b1b;\n  border: 1.5px solid rgba(72, 209, 204, 0.3);\n  border-radius: 22px;\n  padding: 28px;\n  box-shadow: 0 16px 40px rgba(0, 0, 0, 0.45);\n}\n\n.off-booking-card__price-row {\n  margin-bottom: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.off-booking-card__price {\n  font-size: 28px;\n  font-weight: 900;\n  color: #48d1cc;\n}\n\n.off-booking-card__price-label {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 600;\n}\n\n.off-booking-card__desc {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.off-booking-card__availability {\n  margin-bottom: 24px;\n}\n\n.off-booking-card__availability h4 {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.5);\n  margin: 0 0 8px 0;\n}\n\n.off-booking-card__availability p {\n  font-size: 13.5px;\n  line-height: 1.5;\n  color: rgba(255, 255, 255, 0.75);\n  margin: 0;\n}\n\n.off-booking-card__btn-book {\n  background-color: #3bb3ae;\n  border: none;\n  color: #071414;\n  width: 100%;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 700;\n  padding: 14px 20px;\n  border-radius: 30px;\n  cursor: pointer;\n  outline: none;\n  min-height: 48px;\n  text-align: center;\n  box-sizing: border-box;\n  transition: all 0.2s ease;\n}\n\n.off-booking-card__btn-book:hover {\n  opacity: 0.9;\n  box-shadow: 0 4px 12px rgba(59, 179, 174, 0.3);\n}\n\n.off-booking-card__helper-text {\n  text-align: center;\n  font-size: 11.5px;\n  color: rgba(255, 255, 255, 0.35);\n  margin: 6px 0 20px 0;\n}\n\n.off-booking-card__divider {\n  height: 1px;\n  background-color: rgba(255, 255, 255, 0.08);\n  margin-bottom: 20px;\n}\n\n.off-booking-card__btn-quote {\n  background: transparent;\n  border: 1px solid rgba(72, 209, 204, 0.3);\n  color: #48d1cc;\n  cursor: pointer;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 10px 20px;\n  border-radius: 30px;\n  width: 100%;\n  min-height: 40px;\n  transition: all 0.2s ease;\n}\n\n.off-booking-card__btn-quote:hover {\n  background-color: rgba(72, 209, 204, 0.1);\n}\n\n/* Lightbox overlays */\n.off-lightbox {\n  position: fixed;\n  inset: 0;\n  background-color: rgba(0, 0, 0, 0.95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 12000;\n  cursor: zoom-out;\n  backdrop-filter: blur(8px);\n}\n\n.off-lightbox__content {\n  position: relative;\n  max-width: 90%;\n  max-height: 85%;\n}\n\n.off-lightbox__img {\n  max-width: 100%;\n  max-height: 80vh;\n  object-fit: contain;\n  border-radius: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.8);\n}\n\n.off-lightbox__close {\n  position: absolute;\n  top: -48px;\n  right: 0;\n  background: none;\n  border: none;\n  color: #fff;\n  font-size: 36px;\n  cursor: pointer;\n  outline: none;\n}\n\n.off-lightbox__close:hover {\n  color: #48d1cc;\n}\n\n@media (max-width: 960px) {\n  .off-detail-columns {\n    flex-direction: column;\n    gap: 30px;\n  }\n\n  .off-detail-sidebar {\n    width: 100%;\n    position: static;\n  }\n}\n\n@media (max-width: 600px) {\n  .off-detail-hero {\n    height: 300px;\n  }\n\n  .off-detail-body {\n    padding: 0 20px;\n  }\n\n  .off-detail-hero__content {\n    padding: 0 20px 24px 20px;\n  }\n\n  .off-detail-section {\n    padding: 20px;\n  }\n\n  .off-location-split {\n    flex-direction: column;\n  }\n}\n\n@media (max-width: 768px) {\n  .OfferingDetailPage {\n    height: auto !important;\n    overflow: visible !important;\n  }\n}\n\n/* Custom Dropdown Styling */\n.custom-dropdown-container {\n  position: relative;\n  width: 100%;\n}\n\n.custom-dropdown-selected {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  cursor: pointer;\n}\n\n.custom-dropdown-selected.active {\n  border-color: #3bb3ae;\n  box-shadow: 0 0 0 2px rgba(59, 179, 174, 0.15);\n}\n\n.custom-dropdown-options {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  width: 100%;\n  max-height: 220px;\n  overflow-y: auto;\n  border-radius: 10px;\n  border: 1px solid rgba(72, 209, 204, 0.25);\n  background-color: #071414;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);\n  z-index: 1000;\n  padding: 6px 0;\n  box-sizing: border-box;\n}\n\n.custom-dropdown-option {\n  padding: 10px 16px;\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  transition: all 0.15s ease;\n  text-align: left;\n}\n\n.custom-dropdown-option:hover {\n  background-color: rgba(72, 209, 204, 0.1);\n  color: #ffffff;\n}\n\n.custom-dropdown-option.selected {\n  background-color: rgba(72, 209, 204, 0.15);\n  color: #48d1cc;\n  font-weight: 600;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
